(function ($) {
    document.addEventListener("DOMContentLoaded",function(){
        var rdt = getParameterByName('rdt') ?? window.location.href;
        
        const rdturl  = new URL(rdt);
        const currentsid = rdturl.searchParams.get('sid');        

        signinurl = $('.btn-signin').attr('href');
        if(signinurl) {
            try{
                signinurl  = new URL(signinurl, window.location.origin);
                if (window.location.href.endsWith('reset-password') || window.location.href.endsWith('reset-password/')) {
                    signinurl.searchParams.delete('rdt');
                }else{
                    signinurl.searchParams.set('rdt', rdt);
                }
                
                
                currentsid_signin =  currentsid ? currentsid : signinurl.searchParams.get('sid');
                if(currentsid_signin)
                    signinurl.searchParams.set('sid', currentsid_signin);
                
                $('#aw-navbar-root .btn-signin').attr('href', signinurl);
            } catch(e){
                console.log(e)
            }
        }
        subsurl = $('#aw-navbar-root .btn-subscribe').attr('href');
        if(subsurl){
            try{
                subsurl  = new URL(subsurl, window.location.origin);                
                if (window.location.href.endsWith('reset-password') || window.location.href.endsWith('reset-password/')) {
                    subsurl.searchParams.delete('rdt');
                }else{
                    subsurl.searchParams.set('rdt', rdt);
                }

                currentsid_subsurl =  currentsid ? currentsid : subsurl.searchParams.get('sid');
                if(currentsid_subsurl)
                    subsurl.searchParams.set('sid', currentsid_subsurl);
                
                $('#aw-navbar-root .btn-subscribe').attr('href', subsurl);
            } catch(e){
                console.log(e)
            }
        }
        
        regurl = $('#zephr-login-form div:last-child a').attr('href');
        if(regurl) {
            try{
                regurl  = new URL(window.location.origin + regurl);
                regurl.searchParams.set('rdt', rdt);
                currentsid_regurl =  currentsid ? currentsid : regurl.searchParams.get('sid');
                if(currentsid_regurl)
                    regurl.searchParams.set('sid', currentsid_regurl);
                
                $('#zephr-login-form div:last-child a').attr('href', regurl);
                
            } catch(e){
                console.log(e)
            }
        }
    });
})(jQuery)
